import { styled, Grid } from '@mui/material';

const ImageGrid = styled(Grid)`
  background: linear-gradient(
    323.61deg,
    rgba(222, 227, 223, 0.4) 4.23%,
    rgba(189, 198, 190, 0) 77.14%
  );
  position: relative;
  overflow: hidden;
  ${({ theme }) => theme.breakpoints.down('lg')} {
    display: none;
  }
`;

export default ImageGrid;
